<template>
  <div>
    <div
      class="header"
      :class="{ 'header--untouched' : !isTouched }"
    >
      <div class="container">
        <header class="header__section" >
          <h1 class="title">
            <div class="icon">
              <TermometerSVG />
            </div>
            Assuntômetro
          </h1>

          <h2 class="subtitle">
            Entenda o que está gerando mais interesse e curiosidade sobre um termo e inspire-se a criar conteúdo para atingir esse público!
          </h2>

          <h6
            v-if="!hasAccess"
            class="mt-3 text-secondary mb-0"
          >Liberamos 3 utilizações <strong>limitadas</strong> por dia para não assinantes.</h6>
        </header>

        <div class="input-area">
          <input
            v-if="hasAccess || hasAccessRemain"
            v-model="query"
            type="text"
            :placeholder="searchPlaceholder"
            @input="debounceInput"
            :readonly="isLoading"
          />
        </div>
      </div>
    </div>

    <div v-if="isTouched" class="container">
      <div style="position: relative; margin-top: -80px;">
        <div v-if="isEmptyResult && hasAccessRemain" style="text-center">
          <p>Ops, não encontramos resultados para esse termo.</p>
          <p>Para melhores resultados, dê preferência a palavras ao invés de frases.</p>
        </div>
        
        <div v-if="!hasAccessRemain && !isLoading" class="border-secondary alert text-secondary text-center">
          <p class="mb-3">
            <strong>Ops, você atingiu o seu limite diário de pesquisas gratuitas.</strong>
          </p>

          <PrimaryButton
            @click="$router.push({ name: 'subscribe' })"
          >Quero continuar usando o Assuntômetro!</PrimaryButton>
        </div>
        
        <LoadingBox v-if="isLoading" />

        <div class="row" v-else-if="resultSet.length && hasAccessRemain">
          <div
            v-for="result in resultSet" :key="result.group"
            class="col-md-12 d-flex flex-column mb-4"
          >
            <FeatureBox style="flex: 1">
              <span slot="title">{{ result.group.replace('%s', '').trim() }}</span>
              <div slot="description">
                <div class="result">
                  <div
                    v-for="(item, i) in resultItems(result)"
                    :key="i"
                    class="result__item"
                    :class="{'result__item__blur' : !item}"
                  >
                    <span v-if="item">{{ item }}</span>
                    <span v-else>{{ randomPlaceholder() }}</span>
                    <div class="result__item__search">
                      <button class="result__item__search__link" @click="goToSearch('youtube', item)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                          <path d="M15.6656 2.34841C15.4816 1.66041 14.9392 1.11801 14.2512 0.93401C13.0032 0.59961 8 0.599609 8 0.599609C8 0.599609 2.9968 0.59961 1.7488 0.93401C1.0608 1.11801 0.5184 1.66041 0.3344 2.34841C-2.38419e-08 3.59641 0 6.99961 0 6.99961C0 6.99961 -2.38419e-08 10.4028 0.3344 11.6508C0.5184 12.3388 1.0608 12.8812 1.7488 13.0652C2.9968 13.3996 8 13.3996 8 13.3996C8 13.3996 13.0032 13.3996 14.2512 13.0652C14.94 12.8812 15.4816 12.3388 15.6656 11.6508C16 10.4028 16 6.99961 16 6.99961C16 6.99961 16 3.59641 15.6656 2.34841ZM6.4 9.77081V4.22841L11.2 6.99961L6.4 9.77081Z" fill="#F0F0F0"/>
                        </svg>
                      </button>

                       <button class="result__item__search__link" @click="goToSearch('google', item)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M8.15785 6.5912V9.648H12.5139C11.9443 11.5 10.3962 12.8256 8.15785 12.8256C5.49225 12.8256 3.33145 10.6648 3.33145 8C3.33145 5.3352 5.49225 3.1744 8.15785 3.1744C9.35625 3.1744 10.4506 3.6136 11.2947 4.3368L13.5459 2.0856C12.1243 0.7904 10.2331 0 8.15785 0C3.73865 0 0.15625 3.5816 0.15625 8C0.15625 12.4184 3.73865 16 8.15785 16C14.8747 16 16.3571 9.72 15.6987 6.6016L8.15785 6.5912Z" fill="#F0F0F0"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </FeatureBox>

            <div v-if="!hasAccess" class="mt-3 text-center">
              <SecondaryButton
                @click="$router.push({ name: 'subscribe' })"
              >Quero a lista completa!</SecondaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TermometerSVG from '@/components/svg/TermometerSVG'
  import { search } from '@/api/tools/answer.api'
  import SecondaryButton from '@/components/buttons/SecondaryButton'
  import FeatureBox from '@/components/landing/FeatureBox'
  import LoadingBox from '@/components/layout/LoadingBox'
  import _ from 'lodash'

  export default {
    components: {
      FeatureBox,
      LoadingBox,
      TermometerSVG,
      SecondaryButton,
    },

    data: () => ({
      query: '',
      resultSet: [],
      isEmptyResult: false,
      isLoading: false,
      isTouched: false,
      accessRemains: true,
      pageWidth: null
    }),

    metaInfo () {
      return {
        title: 'Assuntômetro - Termômetro de interesse e curiosidade sobre um assunto | CyberClass'
      }
    },

    mounted () {
      if (!this.hasAccess && localStorage.getItem(this.localCacheKey)) {
        this.accessRemains = false
        this.isTouched = true
      }

      window.onresize = () => this.pageWidth = document.body.scrollWidth
    },

    watch: {
      isEmptyResult (newState) {
        if (newState) {
          this.trackNoResult()
        }
      },

      hasAccessRemain (newState) {
        if (!newState) {
          localStorage.setItem(this.localCacheKey, 1);
        }
      }
    },

    computed: {
      ...mapGetters('user', ['user']),

      searchPlaceholder() {
        return this.pageWidth > 992 ? 'Busque uma palavra-chave, exemplo: Youtube' : 'Exemplo: Youtube'
      },

      randomPlaceholder () {
        const placeholders = [
          'espertinho você, hein?!',
          'boa tentativa!',
          'saca de programação? Nos envie seu currículo!',
          'mais sorte na próxima',
          'eu não ia dar esse mole ne',
          'substimou po',
          'não vai ser tão facil assim né?',
          'manja dos HTML?',
          'não é assim tão fácil',
          'no HTML é fácil demais ne',
          'não íamos deixar aqui de bandeja né',
          'opa, eái, blz?',
          'respeito sua tentativa!',
          'nice try!',
        ]

        return () => placeholders[Math.floor(Math.random() * placeholders.length)]
      },

      localCacheKey () {
        const date = new Date;
        const month = date.getUTCMonth() + 1
        const day = date.getUTCDate()
        const year = date.getUTCFullYear()

        return `answer-block-${day}-${month}-${year}`
      },

      hasAccess () {
        return !!this.user && this.user.has_subscription_access
      },

      hasAccessRemain () {
        return !this.isTouched || this.accessRemains
      },

      resultItems () {
        return (result) => {
          return result.items.length ? result.items : [...Array(10).keys()].map(() => null)
        }
      }
    },

    methods: {
      debounceInput: _.debounce(function() {
        this.fetchResult(this.query)
        search
      }, 1500),

      async fetchResult (query) {
        if (query.length < 3) {
          return null;
        }

        this.isLoading = this.isTouched = true

        try {
          const response = await search(query)
          this.resultSet = response.data
        } catch (err) {
          if (err.status === 429) {
            this.accessRemains = false
          }
        }

        this.trackSearch()

        this.isEmptyResult = !this.resultSet.length

        this.isLoading = false
      },

      trackSearch () {
        this.$gtm.trackEvent({ event: 'tools.answer.search', search_term: this.query })
      },

      trackNoResult () {
        this.$gtm.trackEvent({ event: 'tools.answer.no-result', search_term: this.query })
      },

      trackClickProvider (provider) {
        this.$gtm.trackEvent({
          event: 'tools.answer.click-provider',
          value: provider,
          search_term: this.query 
        })
      },

      goToSearch (provider, result) {
        const providers = {
          google: 'https://www.google.com/search?q=',
          youtube: 'https://www.youtube.com/results?search_query='
        }

        this.trackClickProvider(provider)

        const url =  providers[provider] + encodeURIComponent(result.replace('?', ''))
        
        window.open(url,'_blank');
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .container {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .header {
    transition: .5s all;

    &--untouched {
      padding-bottom: 100px;
    }

    &__section {
      text-align: center;
      max-width: 750px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2.67rem;

      .title {
        display: inline-flex;
        align-items: center;
        font-family: $textSecondaryFamily;
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 20px;

        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 60px;
          border-radius: 1.77778rem;
          background: linear-gradient(158deg, rgba(252, 176, 69, 0.80) 4.86%, rgba(253, 29, 29, 0.80) 52.82%, rgba(119, 0, 199, 0.80) 100.77%);
          border-radius: 100%;
          margin-right: 24px;

          svg { 
            fill: #fff; 
          }
        }
      }

      .subtitle {
        font-family: $textPrimaryFamily;
        font-size: 1rem;
        font-weight: 400;
      }
    }
  }

  .input-area {
    margin: 0 auto;
    max-width: 968px;

    input {
      border-radius: 24px;
      padding: 13px 24px;
      border: 0;
      border: 3px solid $yellowBorder;
      background: $white400;
      box-shadow: 0px 4px 8px 2px #12001F, 0px 4px 4px 0px rgba(41, 29, 49, 0.20) inset, 0px 24px 32px -16px rgba(253, 212, 155, 0.25);
    }
  }

  .result {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;

    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 0 0 calc(50% - 5px);
      font-size: 0.89rem;
      padding: 11px 16px;
      border-radius: 36px;
      background: $purple20;
      text-align: left;
    
      &:not(:last-child) { 
        margin-bottom: 16px;
      }

      &__search {
        flex-shrink: 0;

        &__link {
          padding: 8px;

          &:not(:last-child) { 
            margin-right: 5px;
          }
        }
      }

      &__blur &__search {
        display: none;
      }
        
      &__blur {
        span { filter: blur(4px) }
      }

      &:not(&__blur):hover {
        background: darken($purple20, 10);
        box-shadow: 0px 0px 12px 2px #000;
      }
    }

    @media (max-width: 992px) {
      gap: 0;

      &__item { 
        flex-basis: (100%) 
      }
    }
  }
</style>